import React from 'react';
import { Icon } from '@tcc/crate';
import cx from 'classnames';
import styles from './ApplicationsPanel.css';

interface ApplicationHeaderProps {
  name: string;
  date: string;
  thumbnailUri: string;
  isExpanded: boolean;
  onToggle: () => void;
  onSelect: () => void;
  testId: string;
  formatDate: (dateString: string) => string;
}

const ApplicationHeader = ({
  name,
  date,
  thumbnailUri,
  isExpanded,
  onToggle,
  onSelect,
  testId,
  formatDate,
}: ApplicationHeaderProps) => (
  <div 
    className={styles.applicationsPanelHeader}
    onClick={onToggle}
  >
    <div className={styles.applicationsPanelContent}>
      <img 
        src={thumbnailUri} 
        alt={name}
        className={styles.applicationsPanelSatelliteImage}
        onClick={(e) => {
          e.stopPropagation();
          onSelect();
        }}
      />
      <div className={styles.applicationsPanelInfo}>
        <div className={styles.applicationsPanelName}>
          {name}
        </div>
        <div className={styles.applicationsPanelDate}>
          {formatDate(date)}
        </div>
      </div>
    </div>
    <button
      type="button"
      className={styles.applicationsPanelExpandButton}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
    >
      <Icon
        className={cx(styles.applicationsPanelChevron, { 'expanded': isExpanded })}
        glyph={Icon.set.ARROW_RIGHT}
        testId={`${testId}-chevron`}
      />
    </button>
  </div>
);

export default ApplicationHeader;
export type { ApplicationHeaderProps };